module.exports = __webpack_public_path__ + "static/game_loop-e3d64a6a3d50bf7f0905038497d8d47d.png";